import { useDispatch } from 'react-redux'
import { useFiltered } from '../Context'
import moment from 'moment'

import { Container } from './style'


export function Content() {
    const {  
        outdatedBusiness,
        startDate, 
        endDate, 
        atLeastTwo,
        atLeastTwoText,
        openingFiltersDetailed,
        isLoading,
        additionalInfo 
    } = useFiltered()

    const dispatch = useDispatch()


    return(
        <Container isLoading={isLoading}>
            <div className='flexAuto'>
            {
                    !!atLeastTwo.length  ?
                        atLeastTwo.map(elem => (
                            <div 
                                className='card atLeast'
                                key={elem.country}
                                onClick={() => openingFiltersDetailed()}
                            >
                                <span>{elem.country}</span>
                                <p>{atLeastTwoText(elem.regions)}</p>
                            </div>
                        ))
                        :
                        <div className='card'>
                            <p>{additionalInfo}</p>
                        </div>
                }
                
                <div 
                    className='card filterDate'
                    onClick={() => 
                        dispatch({
                            type: 'OPEN_CENTRALIZEDMODAL', 
                            title: "Filtrar período", 
                            componentToShow: 'periodFilter'
                        })
                    }
                >
                    <p>{moment(startDate).format('DD/MM/YYYY HH:mm') + ' - ' + moment(endDate).format('DD/MM/YYYY HH:mm')}</p>
                </div>
            </div>


            <div className='card lastSync'>
                <p className='wideVersionDate'>
                    Última sincronização: {outdatedBusiness.lastSync}h
                </p>
                
                <p className='mobileVersionDate'>
                    {outdatedBusiness.lastSync}h
                </p>

                <div>
                    <p>{outdatedBusiness.name}</p>
                    <span>({outdatedBusiness.city} - {outdatedBusiness.state})</span>
                </div>
            </div>
        </Container>
    )
}
